var _Path, _Path2, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgTabProfile = function SvgTabProfile(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 18 18"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "url(#tab-profile_svg__a)",
    d: "M9 8a3.375 3.375 0 1 0 0-6.75A3.375 3.375 0 0 0 9 8"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "url(#tab-profile_svg__b)",
    d: "M2.25 16.313v-1.688c0-1.492.711-2.923 1.977-3.977C5.493 9.593 7.21 9 9 9s3.507.593 4.773 1.648 1.977 2.485 1.977 3.977v1.688z"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "tab-profile_svg__a",
    x1: 7.059,
    x2: 7.838,
    y1: 1.25,
    y2: 7.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FCF17B"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#E19010"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "tab-profile_svg__b",
    x1: 5.119,
    x2: 5.58,
    y1: 9,
    y2: 16.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FCF17B"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#E19010"
  })))));
};
export default SvgTabProfile;